module.exports = __webpack_public_path__ + "img/CORSeal-2026.c257978c.jpg";